var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-border-0 summaryContainer tw-z-[10]"},[(_vm.loaderVariable)?_c('div',{staticClass:"onLoadingData mt-3"},[_vm._v("\n    Loading...\n")]):_c('div',{staticClass:"text-danger d-flex justify-content-center border border-danger rounded tw-w-100 noData"},[_vm._v("\n    "+_vm._s(_vm.message || "No Data!")+"\n")])])
}
var staticRenderFns = []

export { render, staticRenderFns }